import { buildRouteHead } from "@/lib/seo/routeHead";
import { createFileRoute, redirect } from "@tanstack/react-router";

export const Route = createFileRoute("/en/services/one-vigilance/icsr-management")({
  head: () => buildRouteHead("/en/services/one-vigilance/icsr-management", { noIndex: true }),
  beforeLoad: () => {
    throw redirect({ to: "/en/services/pharmacovigilance/icsr-management", replace: true });
  },
});
